export type TemperatureUnit = "CELSIUS" | "FAHRENHEIT";

export function convertTemperature(
  degrees: number,
  from: TemperatureUnit,
  to: TemperatureUnit,
): number {
  if (from === to) {
    return degrees;
  }
  return to === "FAHRENHEIT"
    ? (degrees * 9) / 5 + 32
    : ((degrees - 32) * 5) / 9;
}
